import React from 'react'

import ResponsivePopover from '@/components/molecules/ResponsivePopover/ResponsivePopover'
import { InfoCircle } from 'react-bootstrap-icons'

const AdsDisclaimerTooltip = () => {
  return (
    <ResponsivePopover
      header="Ad Disclosure"
      description="We financially support the site through advertisers who pay for clearly marked placements."
      buttonText="Learn More"
      buttonLink="/claim-verify-process/"
      buttonType="tertiary"
      placement="bottom-end"
    >
      <div className="flex cursor-pointer items-center text-sm font-normal leading-7 text-gray-900">
        Ads <InfoCircle className="ml-1.5 size-3 text-gray-900" />
      </div>
    </ResponsivePopover>
  )
}

export default AdsDisclaimerTooltip
